$(document).ready(function(){
  $('details.mega-menu').mouseenter(function(){
    $(this).attr('open', 'open');
    $(this).attr('aria-expanded', 'true');
  });

  $('details.mega-menu').mouseleave(function(){
    $(this).removeAttr('open');
    $(this).attr('aria-expanded', 'false');
  });

      $('.emr--checkbox-yes').click(function(evt) {
      $('#with-handle').prop('checked', true);
      $(this).addClass('emr--active');
      $(this).parents('.itgv--handleSelect').find('legend .itgv--selectedValue').text('Yes');
      $('.emr--checkbox-no').removeClass('emr--active');
    });
    
    $('.emr--checkbox-no').click(function(evt) {
      $('#with-handle').prop('checked', false);
      $(this).addClass('emr--active');
      $(this).parents('.itgv--handleSelect').find('legend .itgv--selectedValue').text('No');
      $('.emr--checkbox-yes').removeClass('emr--active');
    });


  $(document).on('change', ".itgv--product-form_color:not('.itgv--pForm__distanceMarker') input[type=radio]", function(){
    var swatchValue = $(this).parents('.itgv--product-form_color').find('input[type=radio]:checked').val();
    var headingText = $(this).parents('.itgv--product-form_color').find('legend').text();
    // console.log(swatchValue);
    // console.log(headingText);
      $(this).parents('.itgv--product-form_color').find('legend .itgv--selectedValue').text(swatchValue);
  });


  $(document).on('change', '.gpo-swatches.color-swatches.gpo-ov-item input[type=radio]', function(){
    var colorSwatchValue = $(this).parent().find('input[type=radio]:checked').val();
    // console.log(colorSwatchValue);
    $('.product__media-wrapper .thumbnail-list .thumbnail-list__item').each(function(){
      var thumbnailAlt = $(this).find('.thumbnail img').attr('alt');
      // console.log(thumbnailAlt);
      if(colorSwatchValue == thumbnailAlt){
        $(this).find('.thumbnail').trigger('click');
      }
    });
  });
  
});

$(document).ready(function(){
  $(".itgv--product-form_color:not('.itgv--handleSelect, .itgv--pForm__distanceMarker')").each(function(){
    var swatchOptionValue = $(this).find('input[type=radio]:checked').val();
    // console.log(swatchOptionValue);
    $(this).find('legend .itgv--selectedValue').text(swatchOptionValue);
  });

  

 /* $(".itgv--product-form_color.itgv--colorSwatches").each(function(){
    var ColorOptionValue = $(this).find('input[type=radio]:checked').val();
    console.log(ColorOptionValue);
    $('.product__media-wrapper .thumbnail-list .thumbnail-list__item').each(function(){
      var thumbnailAltTag = $(this).find('.thumbnail img').attr('alt');
      // console.log(thumbnailAlt);
      if(ColorOptionValue == thumbnailAltTag){
        $(this).find('.thumbnail').trigger('click');
      }
    });
  }); */
 setTimeout(function() {
// $(".gpo-element.gpo-form__group .gpo-ov-wrapper .gpo-ov-item:first-child label").trigger("click");

$(".gpo-choicelist input:checked+label").parents(".gpo-element").addClass("active-str");
$(".gpo-swatches input:checked+label").parents(".gpo-element").addClass("active-str");

   }, 1000);
});

(function() {
    let attempts = 0;
    const maxAttempts = 40; // 8 seconds total

    const selectAllFirstVariants = setInterval(() => {
        // Find all variant groups on the page
        const variantGroups = document.querySelectorAll(".gpo-element.gpo-form__group .gpo-ov-wrapper");

        if (variantGroups.length > 0) {
            variantGroups.forEach((group) => {
                // Find the first label inside THIS specific group
                const firstItem = group.querySelector(".gpo-ov-item:first-child label");
                
                if (firstItem) {
                    firstItem.click();
                    // Optional: Trigger 'change' event to ensure price updates
                    const input = firstItem.querySelector('input') || document.getElementById(firstItem.getAttribute('for'));
                    if (input) {
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            });

            console.log(`Selected first variant in ${variantGroups.length} groups.`);
            clearInterval(selectAllFirstVariants); 
        } else {
            attempts++;
            if (attempts >= maxAttempts) clearInterval(selectAllFirstVariants);
        }
    }, 200);
})();